//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Empty from "@/components/Empty";
import ClipboardJS from "clipboard";
export default {
  name: "member-integral-record",
  components: {
    Empty: Empty
  },
  data: function data() {
    return {
      tabs: [{
        label: "全部",
        name: 0
      }, {
        label: "待发货",
        name: 1
      }, {
        label: "已发货",
        name: 2
      }, {
        label: "已完成",
        name: 3
      }],
      curTab: 0,
      list: [],
      page: 1,
      limit: 10,
      total: 0,
      dlgLogistics: {
        show: false,
        logistics_name: "",
        logistics_number: ""
      },
      dlgComfirmShip: {
        show: false,
        order_id: 0
      }
    };
  },
  computed: {
    tableColumns: function tableColumns() {
      return [{
        label: "商品名称",
        key: "name",
        style: {
          textAlign: "left",
          width: "auto",
          flexGrow: 1
        }
      }, {
        label: "\u5355\u4EF7\uFF08".concat(this.$store.state.commonSetting.point_info.point_name || "", "\uFF09"),
        key: "point",
        style: {
          width: "110px"
        }
      }, {
        label: "订单状态",
        key: "status",
        style: {
          width: "100px"
        }
      }, {
        label: "兑换时间",
        key: "time",
        style: {
          width: "116px",
          wordBreak: "break-word"
        }
      }, {
        label: "操作",
        key: "action",
        style: {
          width: "120px"
        }
      }];
    }
  },
  created: function created() {
    this.requestList();
  },
  mounted: function mounted() {
    this.initClipbord();
  },
  methods: {
    // on event
    onChangeTab: function onChangeTab() {
      this.page = 1;
      this.requestList();
    },
    onLogisticsDetail: function onLogisticsDetail(item) {
      this.dlgLogistics.show = true;
      this.dlgLogistics.logistics_name = item.logistics_name;
      this.dlgLogistics.logistics_number = item.logistics_number;
    },
    onConfirmShip: function onConfirmShip(item) {
      this.dlgComfirmShip.show = true;
      this.dlgComfirmShip.order_id = item.order_id;
    },
    onCopyLogistics: function onCopyLogistics() {
      this.$success("复制成功");
      this.dlgLogistics.show = false;
    },
    onOkConfirmShip: function onOkConfirmShip() {
      var _this = this;

      this.$http.put("/api/app/orderShip/confirm/".concat(this.dlgComfirmShip.order_id)).then(function () {
        _this.dlgComfirmShip.show = false;

        _this.requestList();
      });
    },
    onCurrentChange: function onCurrentChange(val) {
      this.page = val;
      this.requestList();
    },
    // other
    initClipbord: function initClipbord() {
      var that = this; // eslint-disable-next-line no-new

      new ClipboardJS(".logistice-dlg .btn-comfirm", {
        text: function text() {
          return that.dlgLogistics.logistics_number || " ";
        }
      });
    },
    getStatusName: function getStatusName(item) {
      if (item.order_status == 2) {
        return "已完成";
      }

      if (item.is_virtual == 2) {
        switch (item.ship_status) {
          case 1:
            return "待发货";

          case 3:
            return "已发货";
        }
      }

      return "";
    },
    // request
    requestList: function requestList() {
      var _this2 = this;

      this.$http.get("/api/app/user/integral/order", {
        status: this.curTab,
        page: this.page,
        limit: this.limit
      }).then(function (data) {
        _this2.list = data.data;
        _this2.total = data.total;

        _this2.list.forEach(function (i) {
          i.product_price = (i.product_price / 100).toFixed(0);
        });
      });
    }
  }
};